/**
 * Ancho fijo de un filtro del toolbar: no crece ni se achica al cambiar los demás campos.
 * @param {number} width Ancho en píxeles.
 * @returns {Object} `sx` del campo.
 */
export const getFixedFilterFieldSx = (width) => ({
  width,
  flex: `0 0 ${width}px`,
  mt: 0,
});
